import { RumTimeMark, sendRumTimeMark } from '@logistics-frontend/modules/rum'
import {applyPolyfills as initApp} from '@logistics-frontend/polyfills'
import {raise} from '@logistics-frontend/utils'
import React from 'react'
import {createRoot, Root} from 'react-dom/client'

import {App} from './app/App'
import {__ROOT_NODE__} from './shared/config'

sendRumTimeMark(RumTimeMark.BEFORE_JS_FRAMEWORK_INIT)

function getRootNode(): HTMLElement {
  return document.getElementById(__ROOT_NODE__) || raise(`[app] can't find container="${__ROOT_NODE__}"`)
}

function renderRoot(root: Root) {
  root.render(<App />)
  setTimeout(() => sendRumTimeMark(RumTimeMark.REACT_INITED), 0)
}

initApp().then(getRootNode).then(createRoot).then(renderRoot)

sendRumTimeMark(RumTimeMark.JS_FRAMEWORK_INITED)
